export function positiveHandler(/** @type {Function} */ cb) {
    return function(e) {
        if (e >= 0) cb.call(this, e);
    };
}



// WEBPACK FOOTER //
// ./src/plano/utils/fixing.js